import React from 'react';
import { Box, Divider, Typography } from '@mui/material';

type Props = {
  title: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
};

const DrawerSection: React.FC<Props> = ({ title, actions, children }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.25 }}>
    {/* Header */}
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography variant="subtitle1" fontWeight={600}>
        {title}
      </Typography>
      {actions}
    </Box>

    {/* Content */}
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>{children}</Box>

    {/* Divider */}
    <Divider sx={{ my: 1.5 }} />
  </Box>
);

export default DrawerSection;
